export default __webpack_public_path__ + "static/media/php-email-form.03a00197.php";